import { render, staticRenderFns } from "./Qtgl.vue?vue&type=template&id=3aa7e30c&scoped=true&"
import script from "./Qtgl.vue?vue&type=script&lang=js&"
export * from "./Qtgl.vue?vue&type=script&lang=js&"
import style0 from "./Qtgl.vue?vue&type=style&index=0&id=3aa7e30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa7e30c",
  null
  
)

export default component.exports